import type { UserData } from 'chaika-frontend-types/frontend-cms';

import { formatShortFullName } from '@utils/formatShortFullName';

export function getShortFullName(user: UserData): string {
    return formatShortFullName(user);
}
